import React from 'react';

const ChildDots = ({ childIds = [], childrenMap = {}, size = 'sm', showNames = false }) => {
  if (!childIds.length) return null;

  const dotSize = size === 'xs' ? 'w-1.5 h-1.5' : size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5';

  return (
    <span className="inline-flex items-center gap-1">
      {childIds.map(cid => {
        const child = childrenMap[cid];
        if (!child) return null;
        return (
          <span key={cid} className="inline-flex items-center gap-1" title={child.firstName}>
            <span
              className={`${dotSize} rounded-full inline-block flex-shrink-0`}
              style={{ backgroundColor: child.color }}
            />
            {showNames && (
              <span className="text-xs text-fog font-medium">{child.firstName}</span>
            )}
          </span>
        );
      })}
    </span>
  );
};

export default ChildDots;
